import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import { useDropdownToggleProps } from '../../hooks/useDropdownToggleProps';
import { DropdownStateContext } from '../../DropdownStateManager';
/**
 * A wrapper around our DS `IconButton` that provides the props for a dropdown toggle.
 *
 * Note: This component is only the toggle! It doesn't contain a popover or dropdown. If you're looking for something that does,
 * you probably want a preset instead of this. Consider `IconButtonWithContextMenu`.
 *
 * Required contexts: `PopperDropdownContext`, `DropdownStateContext`
 */ const PopperIconToggleButton = (_param)=>{
    var { tooltipText } = _param, rest = _object_without_properties(_param, [
        "tooltipText"
    ]);
    const necessaryToggleProps = useDropdownToggleProps();
    const { isOpen } = useContext(DropdownStateContext);
    return /*#__PURE__*/ React.createElement(IconButton, _object_spread_props(_object_spread({}, necessaryToggleProps, rest), {
        // To prevent the tooltip from showing overtop our dropdown menu
        tooltipText: isOpen ? undefined : tooltipText
    }));
};
PopperIconToggleButton.displayName = 'PopperIconToggleButton';
export default PopperIconToggleButton;
